class Utils {
    static $inject = ['$filter'];

    /**
     * @param {ng.IFilterService} $filter
     */
    constructor($filter) {
        const orderBy = $filter('orderBy');

        Array.prototype.orderBy = function (expression, reverse, comparator) {
            return orderBy(this, expression, reverse, comparator);
        };

        Array.prototype.groupBy = function (prop) {
            return this.reduce(function (groups, item) {
                var val = item[prop];
                groups[val] = groups[val] || [];
                groups[val].push(item);
                return groups;
            }, {});
        };

        Array.prototype.distinct = function(prop) {
            const set = new Set();
            return this.filter(item => {
                if (set.has(item[prop])) return false;
                set.add(item[prop]);
                return true;
            });
        };
    }

    // 

    /**
     * Generate an array of numbers 0..n
     * @param {number} n
     */
    range(n) {
        return [...Array(n + 1).keys()];
    }

    /**
     * Export an array to a .csv file
     *
     * @param {object[]|string} jsonData
     * @param {boolean} showLabel
     * @param {string} filename
     */
    JSONToCSV(jsonData, showLabel, filename) {
        const arrData = 'object' != typeof jsonData ? JSON.parse(jsonData) : jsonData;
        let csv = '';
        if (showLabel) {
            let row = '';
            const header = arrData[0];
            for (let key in header)
                if (header.hasOwnProperty(key))
                    row += key + ',';
            row = row.slice(0, -1);
            csv += row + '\r\n';
        }
        for (let i = 0; i < arrData.length; i++) {
            let row = '';
            const data = arrData[i];
            for (let key in data)
                if (data.hasOwnProperty(key)) {
                    const dataString = data[key] == null ? '' : data[key].toString().replace(/"/g, '""');
                    row += `"${dataString}",`;
                }
            row = row.slice(0, row.length - 1);
            csv += row + '\r\n';
        }
        if ('' === csv) return void alert('Invalid data');
        const universalBOM = "\uFEFF";
        const blob = new Blob([universalBOM, csv], { type: "text/csv; charset=utf-8", encoding: "UTF-8" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.style = 'visibility:hidden';
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    }

}

angular
    .module('app')
    .service('utils', Utils)
    .run(['utils', utils => {} ]); // instantiate the service so the constructor runs and creates the Array functions